var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManufacturingQualityProvenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3332 2.33301V9.33301C16.3331 9.72441 16.4314 10.1096 16.6191 10.453L23.0474 22.213C23.2418 22.5684 23.3404 22.9683 23.3334 23.3733C23.3264 23.7783 23.2141 24.1746 23.0075 24.523C22.8009 24.8715 22.5071 25.1601 22.1551 25.3606C21.8031 25.5611 21.405 25.6664 20.9999 25.6663H6.99989C6.5948 25.6664 6.19666 25.5611 5.84464 25.3606C5.49263 25.1601 5.19888 24.8715 4.99228 24.523C4.78568 24.1746 4.67336 23.7783 4.66636 23.3733C4.65937 22.9683 4.75794 22.5684 4.95239 22.213L11.3807 10.453C11.5684 10.1096 11.6667 9.72441 11.6666 9.33301V2.33301",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52856 17.5H20.4716",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91675 2.33301H18.0834",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturingQualityProvenIcon);
export default __webpack_public_path__ + "static/media/manufacturingQualityProvenIcon.d0913476ec3068f7cf9e980f9d3ea739.svg";
export { ForwardRef as ReactComponent };